import { createRoute } from '@tanstack/react-router';
import { PlatformaPage } from '@/modules/platforma/PlatformaPage';
import { parsePlatformaSearch } from '@/modules/platforma/helpers';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/platforma',
  component: PlatformaPage,
  validateSearch: parsePlatformaSearch,
});
